module.exports = __webpack_public_path__ + "img/10.87e4f7f1.jpg";